<template>
    <v-btn icon @click="auth.logout"> <v-icon>mdi-logout-variant</v-icon></v-btn>
</template>
<script setup>
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();
</script>